import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplyIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.33334 0C1.96534 0 1.66668 0.298667 1.66668 0.666667C1.66668 1.03467 1.96534 1.33333 2.33334 1.33333H11.6667C12.0347 1.33333 12.3333 1.03467 12.3333 0.666667C12.3333 0.298667 12.0347 0 11.6667 0H2.33334ZM2.07814 2.66667C1.82547 2.66667 1.59575 2.80916 1.48308 3.03516L0.403656 5.19271C0.356989 5.28538 0.333344 5.38755 0.333344 5.49089V6C0.333344 6.368 0.63201 6.66667 1.00001 6.66667V10.6667C1.00001 11.4033 1.59668 12 2.33334 12H11.6667C12.4033 12 13 11.4033 13 10.6667V6.66667C13.368 6.66667 13.6667 6.368 13.6667 6V5.49089C13.6667 5.38755 13.643 5.28537 13.5964 5.19271L12.5169 3.03516C12.4043 2.80916 12.1746 2.66667 11.9219 2.66667H2.07814ZM3.00001 6.66667H11C11.368 6.66667 11.6667 6.96533 11.6667 7.33333V10C11.6667 10.368 11.368 10.6667 11 10.6667H3.00001C2.63201 10.6667 2.33334 10.368 2.33334 10V7.33333C2.33334 6.96533 2.63201 6.66667 3.00001 6.66667Z",
		fill: "black",
		fillOpacity: .6
	})]
});
const ForwardRef = forwardRef(SvgReplyIcon);
export { ForwardRef as ReactComponent };
